import { useEffect } from 'react';
import { setPageMeta } from '../utils/seo';
import content from '../content/siteContent.json';

const Studio = () => {
  const { studio, services } = content;

  useEffect(() => {
    setPageMeta({
      title: studio.meta.title,
      description: studio.meta.description,
    });
  }, []);

  return (
    <div className="page">
      <section className="grid">
        <div className="section-title">
          <p className="eyebrow">{studio.intro.eyebrow}</p>
          <h1>{studio.intro.title}</h1>
          <p className="section-lead">{studio.intro.lead}</p>
        </div>
      </section>

      <section className="grid two-col">
        <div className="card">
          <h2>{studio.specialties.title}</h2>
          <ul className="list">
            {studio.specialties.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="card">
          <h2>{studio.style.title}</h2>
          <ul className="list">
            {studio.style.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="grid">
        <div className="section-title">
          <p className="eyebrow">{studio.techStack.eyebrow}</p>
          <h2>{studio.techStack.title}</h2>
          <p className="section-lead">{studio.techStack.lead}</p>
        </div>
        <div className="card-grid">
          {studio.techStack.cards.map((card) => (
            <article className="card card--accent" key={card.title}>
              <h3>{card.title}</h3>
              <p>{card.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="grid">
        <div className="card highlight">
          <p className="eyebrow">{studio.memeMode.eyebrow}</p>
          <h2>{studio.memeMode.title}</h2>
          <p>{studio.memeMode.body}</p>
        </div>
      </section>

      <section className="grid">
        <div className="card highlight">
          <p className="eyebrow">{services.craft.eyebrow}</p>
          <h2>{services.craft.title}</h2>
          <ol className="list steps">
            {services.craft.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
          <p className="section-lead">{services.craft.lead}</p>
        </div>
      </section>
    </div>
  );
};

export default Studio;
